import {getHasUserGivenCalendarConsent, getIsUserCalendarConsentInvalid} from '../../data/meetings/selectors';
import {AppStartListening} from '../../middleware/listenerMiddleware/types';
import {loadAllMeetingsEffect} from './loadAllMeetingsEffect';
import {getAllCalendarDays} from '../../data/calendar/selectors';
import {loadMeetingsAfterWorkdayUpdateEffect, loadMeetingsEffect} from './loadMeetingsEffect';
import {cancelWorkday, createWorkday, replaceWorkday, updateWorkday} from '../../data/workday';
import {
  createGroupWorkspaceReservation,
  registerWorkspaceReservation,
  removeWorkspaceReservation,
  updateWorkspaceReservation,
} from '../../data/workspaceReservation';
import {isAnyOf} from '@reduxjs/toolkit';
import {getUserAnnouncementsEffect} from '../employeeCommunication';

export const addMeetingsListeners = (startListening: AppStartListening) => {
  // Loads all meetings when the user turned on their calendar integration
  startListening({
    predicate: (_action, currentState, previousState) => {
      const days = getAllCalendarDays(currentState);
      if (!days?.length) {
        return false;
      }

      const currentUserConsent = getHasUserGivenCalendarConsent(currentState);
      const previousUserConsent = getHasUserGivenCalendarConsent(previousState);
      return !previousUserConsent && currentUserConsent;
    },
    effect: loadAllMeetingsEffect,
  });

  // Loads all meetings when the consent was invalid but the user reconnected their calendar
  startListening({
    predicate: (_action, currentState, previousState) => {
      const currentUserConsentInvalid = getIsUserCalendarConsentInvalid(currentState);
      const previousUserConsentInvalid = getIsUserCalendarConsentInvalid(previousState);
      const currentCalendarEnabled = getHasUserGivenCalendarConsent(currentState);
      return currentCalendarEnabled && previousUserConsentInvalid && !currentUserConsentInvalid;
    },
    effect: loadAllMeetingsEffect,
  });

  startListening({
    actionCreator: removeWorkspaceReservation.fulfilled,
    effect: loadMeetingsEffect,
  });
  startListening({
    matcher: isAnyOf(createWorkday.fulfilled, updateWorkday.fulfilled),
    effect: loadMeetingsAfterWorkdayUpdateEffect,
  });
  startListening({
    matcher: isAnyOf(
      createWorkday.fulfilled,
      updateWorkday.fulfilled,
      replaceWorkday,
      cancelWorkday,

      registerWorkspaceReservation.fulfilled,
      updateWorkspaceReservation.fulfilled,
      removeWorkspaceReservation.fulfilled,

      createGroupWorkspaceReservation.fulfilled,
    ),
    effect: getUserAnnouncementsEffect,
  });
};
